// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FQRr","tabsBox":"styles_tabsBox__1u4x-","createButton":"styles_createButton__1l0Ki"};